import { render, staticRenderFns } from "./csiPhone.vue?vue&type=template&id=bbe1a9c0&scoped=true&"
import script from "./csiPhone.vue?vue&type=script&lang=js&"
export * from "./csiPhone.vue?vue&type=script&lang=js&"
import style0 from "./csiPhone.vue?vue&type=style&index=0&id=bbe1a9c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe1a9c0",
  null
  
)

export default component.exports